export enum WIZARD_STEPS {
  ADD_DELEGATE = 0,
  SET_LOGO = 1,
  SET_COLOR_PALETTE = 2,
  SET_COMPANY_DATA = 3,
  VERIFY_COMPANY_DATA = 4,
  CONFIGURATION_COMPLETED_THANK_YOU_PAGE = 5,
}
